import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Defaults } from '../helpers/defaults';
import { KarvyRequestModel } from '../models/karvy-request-model';
import { RegisterUserModel } from '../models/create-user.model';
import { map, tap, catchError } from 'rxjs/operators';
import { CVLRespModel, CVLJsonResponse } from '../models/cvl-kra-model';
import { environment } from 'src/environments/environment';
export const invalidDOBMessage = "Invalid DOB.";
import{AESEncryptionService} from './aes_encryption.service'
import { of } from 'rxjs';
import * as CryptoJS from 'crypto-js';

interface IValidatePAN { "data"?: CVLJsonResponse; "error"?: boolean; "message"?: string; }
@Injectable({
  providedIn: 'root'
})
export class UserService {
  closeFeedbackOnOutSideClickSubject: Subject<any>
  closeMobileMenuOutSideClickSubject: Subject<any>
  closeProfileMenuOutSideClickSubject: Subject<any>
  onFrenchiseLogoLoaded: Subject<any>
  constructor(private http: HttpClient, private AES:AESEncryptionService) {
    this.closeFeedbackOnOutSideClickSubject = new Subject<any>();
    this.closeMobileMenuOutSideClickSubject = new Subject<any>();
    this.closeProfileMenuOutSideClickSubject= new Subject<any>();
    this.onFrenchiseLogoLoaded = new Subject<any>();
  }

  public getName(name, position) {
    try {
      return name.split(" ")[position];
    } catch (error) {
      return name;
    }
  }
  public GetClientDetails(params: { params: { panNo: string; dob: any; } }): Observable<any> {
    return this.http.get(Defaults.URL(`/GetClientDetails`), params)
  }

  public validatePAN(params: any,hardFetch?:boolean): Observable<IValidatePAN> {

    const emailMobErr = 'Your KYC status is verified as per KRA. However, your Mobile Number and Email ID is not updated with KRA. Kindly get your Mobile Number and Email ID updated with KRA.';
    let appResErr = 'Based on the PAN Number and DOB entered by you, we are unable to retrive any information from KRA.';
    const nriNroErr = 'In case of NRE/NRO account, Please provide orverseas address otherwise your account is on hold.';
    const requestParams = {
      params: { panNo: params.PAN, dob: params.DOB }
    }

    let observer = new Subject<IValidatePAN>();

    this.GetClientDetails(requestParams).subscribe(response => {

      if (response['success'] && response['data'] && response['data'].length && !hardFetch) {

        observer.next({
          data: response['data'][0],
          error: false,
          message: null
        });

      } else {
        this.http.get(Defaults.URL(`/getClientDetailsFromCVL`), requestParams)
          .pipe(map(response => {

            //let resp = response as CVLRespModel;
            appResErr = response['message'] || appResErr;
            let solicitResponse = response['data']['solicitResponse'];
            let resp = response['data']['solicitPreparedResponse'];


            if (solicitResponse && solicitResponse.ERROR && solicitResponse.ERROR.length && solicitResponse.ERROR[0]) {
              if (solicitResponse.ERROR[0]['ERROR_CODE'] == "WEBERR-012") {
                return {
                  data: null,
                  error: true,
                  message: invalidDOBMessage
                }
              }
            }
            debugger;
            if (resp) {
              if (
                resp.APP_PAN_INQ.APP_RES_STATUS &&
                resp.APP_PAN_INQ.APP_RES_STATUS + "".trim() &&
                (resp.APP_PAN_INQ.APP_RES_STATUS == 'R') &&
                resp.APP_PAN_INQ.APP_MOB_NO
                // && resp.APP_PAN_INQ.APP_EMAIL // EMail check is removed as per requirement 
              ) {
                debugger;
                console.log(resp.APP_PAN_INQ.APP_DOB_DT);
                try {
                  let dt = resp.APP_PAN_INQ.APP_DOB_DT.substr(0, 10);
                  dt = dt.replace(/-|\//g, "-");
                  let dob = dt.split("-");
                  dt = dob[2] + '-' + dob[1] + '-' + dob[0];
                  dt = new Date(dt);
                  resp.APP_PAN_INQ.APP_DOB_DT = dt;
                } catch (error) {
                  console.log(error);
                }



                const data = {
                  "Title": resp.APP_PAN_INQ.APP_GEN == 'M' ? 'Shri' : 'Smt',
                  "FirstName": this.getName(resp.APP_PAN_INQ.APP_NAME, 0),
                  "MiddleName": this.getName(resp.APP_PAN_INQ.APP_NAME, 1),
                  "LastName": this.getName(resp.APP_PAN_INQ.APP_NAME, 2),
                  "Gender": resp.APP_PAN_INQ.APP_GEN,
                  "Email": resp.APP_PAN_INQ.APP_EMAIL,
                  "Mobile": resp.APP_PAN_INQ.APP_MOB_NO,
                  "PAN": resp.APP_PAN_INQ.APP_PAN_NO,
                  "DOB": resp.APP_PAN_INQ.APP_DOB_DT,

                  //CURRENT ADDRESS
                  "CR_MailingAddress": "01",
                  "CRAddressType": "R",
                  "CRFlatRoomDoorBlockNo": resp.APP_PAN_INQ.APP_COR_ADD1,
                  "CRPremisesVillage": resp.APP_PAN_INQ.APP_COR_ADD2,
                  "CRRoadStreet": resp.APP_PAN_INQ.APP_COR_ADD2,
                  "CRAreaLocalityTaluka": resp.APP_PAN_INQ.APP_COR_ADD2,
                  "CR_Landmark": resp.APP_PAN_INQ.APP_COR_ADD3,
                  "CR_PIN_Code": resp.APP_PAN_INQ.APP_COR_PINCD,
                  "CR_City": resp.APP_PAN_INQ.APP_COR_CITY,
                  "CR_State": resp.APP_PAN_INQ.APP_COR_STATE,
                  "CR_Country": "IN",
                  "PR_Addr_SameAs_CR_Addr": resp.APP_PAN_INQ.APP_COR_PINCD == resp.APP_PAN_INQ.APP_PER_PINCD,
                  //PERMANENT ADDRESS
                  "PR_Mailing_Address": "02",
                  "PR_Address_Type": "R",
                  "PRFlatRoomDoorBlockNo": resp.APP_PAN_INQ.APP_PER_ADD1,
                  "PR_Premises_Village": resp.APP_PAN_INQ.APP_PER_ADD2,
                  "PR_Road_Street": resp.APP_PAN_INQ.APP_PER_ADD2,
                  "PR_Area_Locality_Taluka": resp.APP_PAN_INQ.APP_PER_ADD2,
                  "PR_Landmark": resp.APP_PAN_INQ.APP_PER_ADD3,
                  "PR_PIN_Code": resp.APP_PAN_INQ.APP_PER_PINCD,
                  "PR_City": resp.APP_PAN_INQ.APP_PER_CITY,
                  "PR_State": resp.APP_PAN_INQ.APP_PER_STATE,
                  "PR_Country": "IN"
                };
                return {
                  data: data,
                  error: false,
                  message: null
                }
              }
              else return {
                data: null,
                error: true,
                message:
                  (!resp.APP_PAN_INQ.APP_MOB_NO || !resp.APP_PAN_INQ.APP_EMAIL) ? emailMobErr :
                    (!resp.APP_PAN_INQ.APP_RES_STATUS || !(resp.APP_PAN_INQ.APP_RES_STATUS + "").trim()) ? appResErr :
                      (resp.APP_PAN_INQ.APP_RES_STATUS != 'R') ? nriNroErr : ''
              }
            } else {
              return {
                data: null,
                error: true,
                message: appResErr
              }
            }

          })).subscribe(response => {
            observer.next(response);
          }, err => {
            console.log(err.message);
            observer.next({
              data: null,
              error: true,
              message: '-1'
            });
          });
      }
    }, err => {
      console.log(err.message);
      observer.next({
        data: null,
        error: true,
        message: '-1'
      });
    });

    return observer.asObservable();
  }
  public getPanDetailsWM(params: any) {
    return this.http.post(Defaults.URL(`/PanDetailsFromWm`), { panNo: params.PAN });
  } 
  public getPRANDetailsWM(params: any) {
    return this.http.post(Defaults.URL(`/getPRANDetailsWM`), { PRAN: params.PRAN });
  }
  public getStates(country: string): Observable<any> {
    return this.http.get(Defaults.URL(`/stateCountry`), {
      params: { countryCode: country }
    });
  }

  public getDocumentTypeList(): Observable<any> {
    return this.http.get(Defaults.URL(`/GetDocumentMaster`));
  }

  public validateRMCode(code: string): Observable<any> {
    return this.http.post(Defaults.URL('/VaildateRMCode'), {
      RMCode: code
    }, {});
  }
  private registerUserToWM(params: RegisterUserModel): Observable<any> {
    return this.http.post(Defaults.URL('/CreateInvestor'), params, {});
  }
  private pushToKarvy(params: KarvyRequestModel): Observable<any> {
    return this.http.post(`${environment.pushToKarvy}`, params, {});
  }
  /**   
   * @param f :This will be user registration form data.
   * @description: This method will create new Investor also will move forward that investor to KARY Journy.
   */
  public registerNewUser(formData: any): Observable<any> {
    formData.DOB = `${formData.DOB.year}/${formData.DOB.month}/${formData.DOB.day}`;
    return this.http.post(Defaults.URL(`/SaveClientDetails`), formData).pipe(tap(data => {
      let source = sessionStorage["source"];
      if (source) {
        //sessionStorage.removeItem("source");
        this.http.post(
          Defaults.URL(`/UpdateFrenchise`),
          { "source": source, "PAN": formData.PAN })
          .subscribe(
            succ => console.log("Source "),
            fail => console.log("failed to update source"))
      }
      return data;
    }), catchError(error => {
      console.log("error while saving client details.");
      return of(null);
    }));
  }
  public submitToKarvy(karvy: any): Observable<any> {
    const respObservable = new Subject<any>();
    const karvyRequestForm = document.createElement('form') as HTMLFormElement;
    karvyRequestForm.setAttribute('method', "post");
    karvyRequestForm.setAttribute('action', Defaults.KarvyURL());
    Object.keys(karvy).map(key => {
      const i = document.createElement("input");
      i.setAttribute('type', "hidden");
      i.setAttribute('name', key);
      i.setAttribute('value', karvy[key]);
      karvyRequestForm.appendChild(i);
    });
    // karvyRequestForm.target = "_blank"
    document.body.appendChild(karvyRequestForm);
    karvyRequestForm.submit();
    return respObservable.asObservable();
  }
  public uploadDocument(formData: FormData): Observable<any> {
    return this.http.post(Defaults.URL('/UploadDocument'), formData, {});
  }
  public getClientDocDetails(clientID: string): Observable<any> {
    return this.http.get(Defaults.URL('/GetClientDocDetails'), {
      params: {
        "clientId": clientID
      }
    });
  }
  public generateOtp(mobile: string, email?: string): Observable<any> {
    let mobileno = mobile.length > 10 ? mobile.substr(mobile.length - 10, 10) : mobile;
    let req = { mobileNo: mobileno };
    if (email) req = { ...req, ...{ "email": email } };
    let randomNo=Math.floor(Math.random()*100);
    req['random']=randomNo;
    req=this.AES.encrypt(req);
    return this.http.post(Defaults.URL(`/GenerateOTP`), {data:req});
  }

  //***************/ api's for nps login/signup and dashboard starts  /********************/
  // **************************************************************************************/
  public sendOTP(values: any): Observable<any> {
    let randomNo=Math.floor(Math.random()*100);
    values['random']=randomNo;
    values=this.AES.encrypt(values);
    return this.http.post(Defaults.URL(`/GenerateOTP`), {data:values});
  }

  public verifyOTP(values: any): Observable<any> {
    if (values.isEmail) {
      return this.http.get(Defaults.URL(`/VerifyOTP?email=${values.email}&otp=${values.otp}&isEmail=${values.isEmail}&mobileNo=''`));
    }
    else {
      return this.http.get(Defaults.URL(`/VerifyOTP?mobileNo=${values.mobile}&otp=${values.otp}&isEmail=${values.isEmail}&email=''`));
    }
  }

  public signup(values: any): Observable<any> {
    return this.http.post(Defaults.URL(`/SaveClientLogin`), values);
  }

  public checkUserExistence(values: any): Observable<any> {
    return this.http.post(Defaults.URL(`/CheckUserExistence`), values);
  }

  public login(values: any): Observable<any> {
    return this.http.post(Defaults.URL(`/ValidateUser`), values);
  }
  public login_SSO(values: any): Observable<any> {
    return this.http.post(Defaults.URL(`/ValidateUser_SSO`), values);
  }

  public resetPassword(values: any): Observable<any> {
    return this.http.post(Defaults.URL(`/ResetPassword`), values);
  }

  public getTransactionData(values: any): Observable<any> {
    return this.http.post(Defaults.URL(`/GetTransactionData`), values);
  }
  public GetTransactionDetails(values: any): Observable<any> {
    return this.http.post(Defaults.URL(`/GetTransactionDetails`), values);
  }
  public getPortfolioOverviewData(values: any): Observable<any> {
    return this.http.post(Defaults.URL(`/GetPortfolioOverviewData`), values);
  }

  public getTransactionHistory(values: any): Observable<any> {
    return this.http.post(Defaults.URL(`/GetTransactionHistory`), values);
  }

  public uploadProfilePic(values: any): Observable<any> {
    return this.http.post(Defaults.URL(`/UploadProfileImage`), values);
  }

  public removeProfilePic(values:any): Observable<any> {
    return this.http.post(Defaults.URL(`/RemoveProfilePic`), values);
  }

  public updateProfile(values: any): Observable<any> {
    return this.http.post(Defaults.URL(`/UpdateProfile`), values);
  }

  public notifyUser(values: any): Observable<any> {
    return this.http.post(Defaults.URL(`/SendSecurityMessage`), values);
  }

  //**************/ api's for nps login/signup and dashboard ends
  // **************************************************************************************/


  public setFeedback(model: any): Observable<any> {

    return this.http.post(Defaults.URL(`/SetFeedback`), model);
  }
  public validateOtp(mobile: string, otp: string): Observable<any> {
    let mobileno = mobile.length > 10 ? mobile.substr(mobile.length - 10, 10) : mobile;
    return this.http.get(Defaults.URL(`/VerifyOTP?mobileNo=${mobileno}&otp=${otp}`));
  }
  public SaveNonKYCCustomer(params: any): Observable<any> {
    return this.http.post(Defaults.URL('/SaveNonKYCCustomer'), params, {});

  }
  public CheckForPRANExistOrNot(params: any): Observable<any> {
    //localhost:8005/nps/api/v1/CheckPRANGeneratedOrNot?panNo=AGUPP4761B
    return this.http.post(Defaults.URL('/UnifiedDeDupCheck'), params);
  }
  public GetCities(params?: any): Observable<any> {
    return this.http.get(Defaults.GetCityURL(), { params: params });

  }
  public GetCorpLists(params?: any): Observable<any> {
    return this.http.get(Defaults.URL("/GetCorpLists"), { params: params });

  }
  public PushLeadToSalesforce(params: any): Observable<any> {
    return this.http.post(Defaults.GetSalesForceURL(), params, {});
  }
  public onCloseFeedbackOnOutSideClick(): Observable<any> {
    return this.closeFeedbackOnOutSideClickSubject.asObservable();
  }
   public onCloseMobileMenuOutSideClick(): Observable<any> {
    return this.closeMobileMenuOutSideClickSubject.asObservable();
  }
  public onCloseProfileMenuOutSideClick(): Observable<any> {
    return this.closeProfileMenuOutSideClickSubject.asObservable();
  }
  public updateSubsequentStatus(params: any): Observable<any> {
    return this.http.post(Defaults.URL('/UpdateSubsequent'), params, {});
  }

  /**
   * Corporate Services
   */
  public SaveCorp(params: any): Observable<any> {
    return this.http.post(Defaults.URL('/SaveCorporate'), params, {});

  }
  public verifyCorp(params: any): Observable<any> {
    return this.http.post(Defaults.URL('/VerifyCorp'), params, {});

  }
  public SaveCorpEmp(formData: any): Observable<any> {
    formData.DOB = `${formData.DOB.year}/${formData.DOB.month}/${formData.DOB.day}`;
    return this.http.post(Defaults.URL('/SaveCorpEmp'), formData, {});

  }
  public updateCorpStatus(params: any): Observable<any> {
    return this.http.post(Defaults.URL('/UpdateCorpStatus'), params, {});
  }
  public updateCorpEmpStatus(params: any): Observable<any> {
    return this.http.post(Defaults.URL('/UpdateCorpEmpStatus'), params, {});
  }
  public UpdateJuorneyStatus(params: any): Observable<any> {
    return this.http.post(Defaults.URL('/UpdateJuorneyStatus'), params, {});
  }
  public GetFrenchiseLogo(): Observable<any> {
    let params = { "source": sessionStorage["source"] }
    return this.http.post(Defaults.URL('/GetFrenchiseLogo'), params, {}).pipe(tap(data => {
      this.onFrenchiseLogoLoaded.next(data);
      return data;
    }));
  }
  public onLogoLoaded(): Observable<any> {
    return this.onFrenchiseLogoLoaded.asObservable();
  }

  public logout(token:any): Observable<any>{
    return this.http.post((Defaults.URL('/logout')),token);  
  }
  //webengage Encryption
  public webengageEncrypt(obj: any){
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('key', environment.webEncryptKey);
    headers = headers.append('secret', environment.webEncryptSecret);
    return this.http.post(Defaults.WebengageEncryption(),obj, { headers: headers });
  }

  public decode_token(params: any) {
    return this.http.post(Defaults.SSO_decode_token(`/decode-token`), { token: params.token });
  } 
// -----DEV SSO testing API--------------------
  public callback_SSO(obj:any) {
    return this.http.post(Defaults.URL('/callback'), obj,{  withCredentials: true  });
  }

  public saveIssFormReq(data: FormData): Observable<any>{
    console.log("Saving ISS Form Data: ", data);
    return this.http.post(Defaults.URL('/IssFormRequest'), data);
  }

  public decryptPAN(encryptedPAN: string): string {

    const key = CryptoJS.enc.Utf8.parse('B@J@J@12345@@@@@');
    
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Base64.parse(encryptedPAN) },
      key,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    );
  
    return decrypted.toString(CryptoJS.enc.Utf8);
  } 
}
